import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ArrowDown, ArrowUp, Plus, Trash2, X } from "lucide-react";
import { FIELD_TYPES, HAS_OPTIONS } from "@/lib/checklistTypes";

// One field row in the checklist builder, incl. the editable drop-down options list.
export const ChecklistFieldEditor = ({ item, idx, testid, onChange, onDelete, onMove, isFirst, isLast }) => {
  const set = (k, v) => onChange({ ...item, [k]: v });
  const opts = item.options || [];
  const setOpt = (i, v) => set("options", opts.map((o, j) => (j === i ? v : o)));
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-3 space-y-2" data-testid={testid}>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs font-mono text-slate-400 w-6">{idx + 1}.</span>
        <Select value={item.type} onValueChange={(v) => onChange({ ...item, type: v, options: HAS_OPTIONS.includes(v) && !opts.length ? ["Option 1"] : opts })}>
          <SelectTrigger className="w-56 h-10" data-testid={`${testid}-type`}><SelectValue /></SelectTrigger>
          <SelectContent>{FIELD_TYPES.map((f) => <SelectItem key={f.value} value={f.value}>{f.label}</SelectItem>)}</SelectContent>
        </Select>
        <Input data-testid={`${testid}-label`} placeholder={item.type === "info" ? "Information to show" : "Question / item"} value={item.label}
          onChange={(e) => set("label", e.target.value)} className="h-10 flex-1 min-w-[180px]" />
        {item.type !== "info" && (
          <label className="flex items-center gap-1.5 text-sm text-slate-600">
            <Checkbox checked={!!item.required} onCheckedChange={(v) => set("required", !!v)} data-testid={`${testid}-required`} />Required
          </label>
        )}
        <Button size="icon" variant="ghost" className="h-9 w-9" disabled={isFirst} onClick={() => onMove(-1)} data-testid={`${testid}-up`}><ArrowUp className="h-4 w-4" /></Button>
        <Button size="icon" variant="ghost" className="h-9 w-9" disabled={isLast} onClick={() => onMove(1)} data-testid={`${testid}-down`}><ArrowDown className="h-4 w-4" /></Button>
        <Button size="icon" variant="ghost" className="h-9 w-9 text-red-500" onClick={onDelete} data-testid={`${testid}-delete`}><Trash2 className="h-4 w-4" /></Button>
      </div>
      {HAS_OPTIONS.includes(item.type) && (
        <div className="pl-8 space-y-1.5" data-testid={`${testid}-options`}>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Drop-down choices</p>
          {opts.map((o, i) => (
            <div key={i} className="flex items-center gap-2">
              <Input value={o} onChange={(e) => setOpt(i, e.target.value)} className="h-9 max-w-sm" data-testid={`${testid}-option-${i}`} />
              <Button size="icon" variant="ghost" className="h-8 w-8 text-slate-400" onClick={() => set("options", opts.filter((_, j) => j !== i))} data-testid={`${testid}-option-remove-${i}`}><X className="h-4 w-4" /></Button>
            </div>
          ))}
          <Button size="sm" variant="outline" onClick={() => set("options", [...opts, `Option ${opts.length + 1}`])} data-testid={`${testid}-option-add`}><Plus className="h-3.5 w-3.5 mr-1" />Add choice</Button>
        </div>
      )}
    </div>
  );
};
